// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const localStorageAvailable = typeof Storage !== 'undefined';

export enum LocalStorageKeys {
  DisplayFirstName = 'DisplayFirstName',
  DisplayLastName = 'DisplayLastName',
  DisplayEmail = 'DisplayEmail',
  DisplayMobileNumber = 'DisplayMobileNumber',
  DisplayIMONumber = 'DisplayIMONumber',
  DisplayHEXID = 'DisplayHEXID',
  DisplayMMSINumber = 'DisplayMMSINumber',
  DisplayTC = 'DisplayTC',
  DisplayPC = 'DisplayPC',
  DisplaySC = 'DisplaySC'
}

/**
 * Get display first name from local storage.
 */
export const getDisplayFirstNameFromLocalStorage = (): string | null =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplayFirstName);

/**
 * Save display first name into local storage.
 */
export const saveDisplayFirstNameToLocalStorage = (displayFirstName: string): void =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplayFirstName, displayFirstName);

/**
 * Get display last name from local storage.
 */
export const getDisplayLastNameFromLocalStorage = (): string | null =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplayLastName);

/**
* Save display last name into local storage.
*/
export const saveDisplayLastNameToLocalStorage = (displayLastName: string): void =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplayLastName, displayLastName);

/**
* Get display email from local storage.
*/
export const getDisplayEmailFromLocalStorage = (): string | null =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplayEmail);

/**
* Save display email into local storage.
*/
export const saveDisplayEmailToLocalStorage = (displayEmail: string): void =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplayEmail, displayEmail);

/**
* Get display mobile number from local storage.
*/
export const getDisplayMobileFromLocalStorage = (): string | null =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplayMobileNumber);

/**
* Save display mobile number into local storage.
*/
export const saveDisplayMobileToLocalStorage = (displayMobile: string): void =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplayMobileNumber, displayMobile);

/**
* Get display IMO Number from local storage.
*/
export const getDisplayIMOFromLocalStorage = (): string | null =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplayIMONumber);

/**
* Save display IMO number into local storage.
*/
export const saveDisplayIMOToLocalStorage = (displayIMO: string): void =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplayIMONumber, displayIMO);

/**
* Get display HEX ID from local storage.
*/
export const getDisplayHEXIDFromLocalStorage = (): string | null =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplayHEXID);

/**
* Save display HEXID into local storage.
*/
export const saveDisplayHEXIDToLocalStorage = (displayHEXID: string): void =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplayHEXID, displayHEXID);

/**
* Get display MMSI from local storage.
*/
export const getDisplayMMSIFromLocalStorage = (): string | null =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplayMMSINumber);

/**
* Save display MMSI into local storage.
*/
export const saveDisplayMMSIToLocalStorage = (displayMMSI: string): void =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplayMMSINumber, displayMMSI);

/**
* Get display TC local storage.
*/
export const getDisplayTCFromLocalStorage = () =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplayTC);

/**
* Save display TC local storage.
*/
export const saveDisplayTCToLocalStorage = (displayTC: string) =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplayTC, displayTC);


/**
* Get display TC local storage.
*/
export const getDisplayPCFromLocalStorage = (): string | null =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplayPC);

/**
* Save display TC local storage.
*/
export const saveDisplayPCToLocalStorage = (DisplayPC: string) =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplayPC, DisplayPC);

/**
* Get display TC local storage.
*/
export const getDisplayDCFromLocalStorage = () =>
  window.sessionStorage.getItem(LocalStorageKeys.DisplaySC);

/**
* Save display TC local storage.
*/
export const saveDisplaySCToLocalStorage = (DisplaySC: string) =>
  window.sessionStorage.setItem(LocalStorageKeys.DisplaySC, DisplaySC);
